export { AppTranslateLoader } from './app-translate-loader';

import { zh_TW } from './zh_TW';

// zh_TW currently has the most complete key set of the 7 languages; used as the
// canonical shape for autocomplete/type-checking when authoring translation keys.
export type AppTranslations = typeof zh_TW;
export type AppTranslationKey = keyof AppTranslations;
